import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="pt-32 pb-16 md:pt-40 md:pb-24 px-6 max-w-6xl mx-auto" data-id="element-82">
      <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-83">
        <div className="flex-1 text-center md:text-left" data-id="element-84">
          <FadeIn data-id="element-85">
            <h1 className="text-5xl md:text-7xl font-bold text-dark mb-6 leading-tight" data-id="element-86">
              Deja de ser <span className="italic text-gold" data-id="element-87">Invisible.</span>
            </h1>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-88">
            <p className="text-xl md:text-2xl text-dark-light mb-6 font-serif italic" data-id="element-89">
              En Estados Unidos, tu crédito decide si vives en tu propia casa o
              en la de alguien más. Hoy eso cambia.
            </p>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-90">
            <p className="text-base md:text-lg text-dark-light mb-10 leading-relaxed max-w-2xl" data-id="element-91">
              La Guía Maestra para dominar el sistema de crédito americano desde
              cero: cómo leer tu reporte, borrar deudas injustas con cartas
              legales incluidas y calificar para tu hipoteca. Todo en un solo
              manual descargable. Sin pagarle mensualidades a nadie.
            </p>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-92">
            <Button className="w-full md:w-auto" data-id="element-93">
              [ DESCARGAR MI PASAPORTE FINANCIERO — $16 AHORA ]
            </Button>
            <div className="mt-4 text-xs text-dark-light/70 flex items-center justify-center md:justify-start gap-2" data-id="element-94">
              <span data-id="element-95">Pago 100% seguro</span> • <span data-id="element-96">Descarga inmediata</span>
            </div>
          </FadeIn>
        </div>
        <div className="flex-1 w-full max-w-md md:max-w-none" data-id="element-97">
          <FadeIn delay={0.5} data-id="element-98">
            <div className="relative" data-id="element-99">
              <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full transform -translate-y-1/2" data-id="element-100"></div>
              <img src="https://cdn.magicpatterns.com/uploads/oG4uaCyfqmADd4q1NbZQz3/imagen.png" alt="El Pasaporte Financiero Bundle" className="relative z-10 w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-101" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}